fc_SwiperSlider_CustomData();

function fc_SwiperSlider_CustomData() {
    var sliderSelector = ".swiper-container",
        dataDefault = {};

    var eachSlider = document.querySelectorAll(sliderSelector);

    [].forEach.call(eachSlider, function (slider, index, arr) {
        var data = slider.getAttribute("data-slide") || {};
        if (data) {
            var dataOptions = JSON.parse(data);
            slider.options = Object.assign({}, dataDefault, dataOptions);
            var swiper = new Swiper(slider, slider.options);
        }
    });
}


function fc_PlayMusic() {
    const buttons = document.querySelectorAll(".unmute-btn");
    const wrappers = document.querySelectorAll(".video-custom-wrapper");

    wrappers.forEach(wrapper => {
        const video = wrapper.querySelector("video");
        if (video) {
            video.muted = true;
            video.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        }
    });

    buttons.forEach(button => {
        button.addEventListener("click", () => {
            const wrapper = button.closest(".video-custom-wrapper");
            const video = wrapper?.querySelector("video");

            if (!video) return;

            video.muted = !video.muted;

            if (video.paused) {
                video.play().catch(() => {
                });
            }

            button.classList.toggle("is-playing-sound", !video.muted);
        });
    });
}

document.addEventListener("DOMContentLoaded", fc_PlayMusic);

setTimeout(function () {
    fc_ChangeVariable();
}, 500)

function fc_ChangeVariable() {
    document.querySelectorAll(".product-variable").forEach((card) => {
        const swatches = card.querySelectorAll(".html_color_names");
        if (!swatches.length) return;

        const primaryImg = card.querySelector(".primary-image");
        const secondaryImg = card.querySelector(".secondary-image");

        if (!primaryImg) return;

        if (secondaryImg) {
            secondaryImg.remove();
        }

        swatches.forEach((swatch) => {
            const hoverSrc = swatch.dataset.imageHover;
            if (!hoverSrc) return;

            swatch.addEventListener("mouseenter", () => {
                if (primaryImg.src !== hoverSrc) {
                    primaryImg.src = hoverSrc;
                    primaryImg.removeAttribute("srcset");
                }
            });
        });
    });
}


function fc_LazyLoad() {
    const lazyImages = document.querySelectorAll(".lazyload:not(.loaded)");
    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                img.src = img.dataset.src;
                img.onload = () => img.classList.add("loaded");
                obs.unobserve(img);
            }
        });
    });
    lazyImages.forEach(img => observer.observe(img));
}

document.addEventListener("DOMContentLoaded", () => {
    fc_LazyLoad();
});


fc_ThumbSwiper();

function fc_ThumbSwiper() {
    var sliderSelector = ".swiper-container-pd-thumb",
        dataDefault = {};
    var eachSlider = document.querySelectorAll(sliderSelector);

    [].forEach.call(eachSlider, function (slider, index, arr) {
        var data = slider.getAttribute("data-slide") || {};
        var pd_sync_id = slider.getAttribute("data-swiper-v");
        if (data) {
            var dataOptions = JSON.parse(data);
            var thumbsOptions = dataOptions.thumb;
            var thumbsInit;
            if (thumbsOptions) {
                var thumbImages = slider.querySelectorAll("img");
                var slides = "";
                thumbImages.forEach(function (img) {
                    slides +=
                        "\n<div class='swiper-slide'>\n<img class='img-fluid' src=".concat(
                            img.src + "&width=246",
                            " alt='image' loading='lazy'/>\n</div>\n"
                        );
                });
                var thumbs = document.createElement("div");
                thumbs.setAttribute("class", "swiper js-thumb");
                thumbs.innerHTML = "<div class='swiper-wrapper'>".concat(
                    slides,
                    "</div>"
                );
                thumbs.insertAdjacentHTML(
                    "beforeend",
                    '<div class="cs-navigation"><div class="cs-swiper-button cs-swiper-button-prev"><span></span></div><div class="cs-swiper-button cs-swiper-button-next"><span></span></div></div>'
                );
                if (thumbsOptions.parent) {
                    var parent = document.querySelector(thumbsOptions.parent);
                    parent.parentNode.appendChild(thumbs);
                } else {
                    slider.parentNode.appendChild(thumbs);
                }
                thumbsOptions.options = Object.assign(
                    {
                        navigation: {
                            nextEl: thumbs.querySelector(".cs-swiper-button-next"),
                            prevEl: thumbs.querySelector(".cs-swiper-button-prev"),
                        },
                    },
                    thumbs,
                    thumbsOptions
                );
                thumbsInit = new window.Swiper(thumbs, thumbsOptions.options);
                slider.options = Object.assign(
                    {
                        thumbs: {
                            swiper: thumbsInit,
                        },
                    },
                    dataDefault,
                    dataOptions
                );
                var swiper = new Swiper(slider, slider.options);
            } else {
                slider.options = Object.assign({}, dataDefault, dataOptions);
                var swiper = new Swiper(slider, slider.options);
            }
            const syncIdIndex = window.localStorage.getItem(
                `pd_sync_${pd_sync_id}`
            );
            if (syncIdIndex != null) {
                swiper.slideTo(syncIdIndex, 0);
            }
            var height = document.querySelector(".style-vertical .swiper-horizontal");
            if (height) {
                thumbs.style.height = height.offsetHeight + "px";
            }

        }
    });
}

fc_Parallax();

function fc_Parallax() {
    // jarallax يُحمَّل الآن بعد اكتمال الصفحة (انظر layout/theme.liquid) حتى لا
    // يزاحم أول رسمة. لذا قد تُستدعى هذه الدالة قبل توفّره — نخرج بهدوء،
    // ويعيد محمّل السكربت استدعاءها فور جهوزيته.
    if (typeof jarallax === 'undefined') return;
    jarallax(document.querySelectorAll('.jarallax'), {
        imgSize: 'object-fit'
    });
}

fc_Compare();

function fc_Compare() {
    const viewers = document.querySelectorAll(".image-compare");
    const options = {
        smoothingAmount: 100,
        hoverStart: true
    };
    viewers.forEach((element) => {
        let view = new ImageCompare(element).mount();
    });
}

document.addEventListener('mousemove', fc_ParrallaxImages);

function fc_ParrallaxImages(e) {
    var movedX = (e.clientX * -0.3 / 8);
    var movedY = (e.clientY * -0.3 / 8);
    var elements = document.getElementsByClassName('js-parallaxed');

    for (var i = 0; i < elements.length; i++) {
        elements[i].style.transform = 'translate(' + movedX + 'px,' + movedY + 'px)';
    }
}

function handleClickOnDetails() {
    let detailsOpened = document.querySelectorAll(
        ".details-toggle details[open]"
    );

    for (const item of detailsOpened) {
        if (this != item) {
            item.removeAttribute("open");
        }
    }
}

fc_Details_toggle();

function fc_Details_toggle() {
    document.addEventListener('click', function (event) {
        const detailsElement = event.target.closest(".details-toggle details");
        if (detailsElement) {
            handleClickOnDetails.call(detailsElement);
        }
    });
}

function handleClickOnDetails() {
    let detailsOpened = document.querySelectorAll(".details-toggle details[open]");
    detailsOpened.forEach(function (item) {
        if (this !== item) {
            item.removeAttribute("open");
        }
    });
}

fc_Hotspots();

function fc_Hotspots() {
    document.addEventListener('DOMContentLoaded', function () {
        const items = document.querySelectorAll('.item-hotspots');

        items.forEach(item => {
            const btn = item.querySelector('.btn-icon-plus');
            const content = item.querySelector('.content-hotspots');
            const closeModalBtn = content.querySelector('.btn-close-modal');

            btn.addEventListener('click', function (e) {
                e.stopPropagation();
                items.forEach(otherItem => {
                    if (otherItem !== item) {
                        otherItem.classList.remove('active');
                    }
                });
                const isActive = item.classList.toggle('active');
                if (isActive) {
                    document.body.classList.add('active-overlay');
                } else {
                    const anyItemActive = Array.from(items).some(item => item.classList.contains('active'));
                    if (!anyItemActive) {
                        document.body.classList.remove('active-overlay');
                    }
                }
            });

            content.addEventListener('click', function (e) {
                e.stopPropagation();
            });

            if (closeModalBtn) {
                closeModalBtn.addEventListener('click', function (e) {
                    e.stopPropagation();
                    item.classList.remove('active');
                    document.body.classList.remove('active-overlay');
                });
            }
        });

        document.addEventListener('click', function () {
            items.forEach(item => {
                item.classList.remove('active');
            });
            document.body.classList.remove('active-overlay');
        });
    });
}

fc_Dropdown();

function fc_Dropdown() {
    document.addEventListener('click', function (event) {
        const allDropdowns = document.querySelectorAll('.custom-dropdown');
        const dropdownButtons = document.querySelectorAll('.dropdown-button');
        if (event.target.classList.contains('dropdown-button')) {
            const index = [...dropdownButtons].indexOf(event.target);
            const dropdown = allDropdowns[index];
            allDropdowns.forEach(d => {
                if (d !== dropdown) {
                    d.classList.remove('active');
                }
            });
            dropdown.classList.toggle('active');
        }

        if (event.target.classList.contains('js-close-custom')) {
            const index = [...document.querySelectorAll('.js-close-custom')].indexOf(event.target);
            const dropdown = allDropdowns[index];
            dropdown.classList.remove('active');
            event.stopPropagation();
        } else if (!event.target.closest('.custom-dropdown') && !event.target.closest('.dropdown-button')) {
            allDropdowns.forEach(dropdown => {
                dropdown.classList.remove('active');
            });
        }
    });
}

if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
        fc_SwiperSlider_CustomData();
        fc_Details_toggle();
        fc_Dropdown();
        fc_Hotspots();
        fc_Parallax();
        fc_LazyLoad();
        fc_Compare();
    });
    document.addEventListener("shopify:section:select", () => {
        fc_SwiperSlider_CustomData();
    });
    document.addEventListener("shopify:section:deselect", () => {
    });
    document.addEventListener("shopify:block:select", () => {
    });
    document.addEventListener("shopify:block:deselect", () => {
    });
    document.addEventListener("shopify:inspector:activate", () => {
    });
    document.addEventListener("shopify:inspector:deactivate", () => {
    });
}

var closebtns = document.getElementsByClassName("js-close");
var i;

for (i = 0; i < closebtns.length; i++) {
    closebtns[i].addEventListener("click", function () {
        this.parentElement.style.display = "none";
    });
}
